export default __webpack_public_path__ + "static/media/WinterClothes_24.b5369041.png";